import React from 'react'
import PropTypes from 'prop-types'

const Option = ({ data, withText = true }) => {
  const baseUrl = 'https://cookie-script.com/templates/userpanel/images/flags/';
  return (
    <div className='select-custom-option'>
      <img src={`${baseUrl}/${data.value.toUpperCase()}.svg`} className='me-2 ms-1 select-flag-image' alt=''/>
      {withText && data.label}
    </div>
  )
}

export default Option

Option.propTypes = {
  data: PropTypes.shape({
    value: PropTypes.string,
    label: PropTypes.string,
  }).isRequired
}